














































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({})
export default class PaginationWidget extends Vue {

  @Prop({ type: Number, default: 3 })
  private maxVisibleButtons!: number;

  @Prop(Number)
  private totalRecords!: number;

  @Prop(Number)
  private perPage!: number;

  @Prop(Boolean)
  private isPagingWithPages!: boolean;

  @Prop({ type: Number, default: 0 })
  private pageNumber!: number;

  private currentPage: number = 0;
  private totalPages: number = 1;
  private recordsPerPage: number = 10;
  private records: number[] = [5, 10, 25, 50, 100, 500];

  private mounted() {
    this.recordsPerPage = this.perPage || 10;
    this.totalPages = Math.ceil(this.totalRecords > this.recordsPerPage ?
      this.totalRecords / this.recordsPerPage : 1);
    this.currentPage = this.pageNumber + 1;
  }

  private onPageChange(page: number): void {
    this.currentPage = page;
    this.$emit('onPageChange', this.currentPage);
  }

  private startPage(): number {
    // When on the first page
    if (this.currentPage === 1) {
      return 1;
    }
    // When on the last pages
    if (this.currentPage >= this.totalPages - this.maxVisibleButtons + 2) {
      return this.totalPages - this.maxVisibleButtons + 1;
    } else {
      // When in between
      return this.currentPage - 1;
    }
  }

  private pages(): any {
    const range: any = [];
    const endPage = Math.min(this.startPage() + this.maxVisibleButtons - 1, this.totalPages);
    for (let i = this.startPage(); i <= endPage; i++) {
      range.push({
        name: i,
        isDisabled: i === this.currentPage,
      });
    }
    return range;
  }

  private isInFirstPage(): boolean {
    return this.currentPage === 1;
  }

  private isInLastPage(): boolean {
    return this.currentPage === this.totalPages;
  }

  private isFirstPageShow(): boolean {
    return this.currentPage <= 2;
  }

  private isLastPageShow(): boolean {
    return this.currentPage >= this.totalPages - this.maxVisibleButtons + 2;
  }

  private isPageActive(page: number): boolean {
    return this.currentPage === page;
  }

  private onClickFirstPage(): void {
    this.onPageChange(1);
  }

  private onClickPreviousPage(): void {
    this.onPageChange(this.currentPage - 1);
  }

  private onClickPage(page: number): void {
    this.onPageChange(page);
  }

  private onClickNextPage(): void {
    this.onPageChange(this.currentPage + 1);
  }

  private onClickLastPage(): void {
    this.onPageChange(this.totalPages);
  }

  @Watch('totalRecords')
  private onTotalRecordsChanged(newVal: number, oldVal: number): void {
    this.totalPages = Math.ceil(this.totalRecords > this.recordsPerPage ?
      this.totalRecords / this.recordsPerPage : 1);
  }

  private onRecordsChanged(newVal: any, oldVal: number): void {
    this.recordsPerPage = +newVal.target.value;
    this.totalPages = Math.ceil(this.totalRecords > this.recordsPerPage ?
      this.totalRecords / this.recordsPerPage : 1);
    this.currentPage = 1;
    this.$emit('onRecordsPerPageChanged', this.recordsPerPage);
  }

}
